import { authStore } from '../stores/authStore'
import { toast } from 'react-toastify'

export interface RetentionCustomerRedirectPayload {
  outletId: string | number
  customerTypeId?: number | null
  customerType?: string | null
}

/**
 * Constructs and opens the Sales App checkout URL for a retention/recency customer,
 * passing crm_source, crm_user_id, customer_type_id, and customer_type in query parameters.
 */
export function openSalesAppForRetentionCustomer(customer: RetentionCustomerRedirectPayload) {
  const crmUserId = authStore.user?.userId;
  if(!crmUserId){
    toast.error("UserId not found");
    return;
  }

  // const SALES_APP_URL = import.meta.env.VITE_SALES_APP_URL+"/customer/detail"+"/"+String(customer.outletId)+"?crm_source=CRM_RECENCY&crm_userId="+crmUserId+"";

  const SALES_APP_URL = `${import.meta.env.VITE_SALES_APP_URL}/customer/detail/${customer.outletId}?crm_source=CRM_RECENCY&crm_userId=${crmUserId}`

  try {
    // const url = new URL(SALES_APP_URL)
    // console.log("sales url ", SALES_APP_URL);
    // url.searchParams.set('outletId', String(customer.outletId))
    // url.searchParams.set('crm_source', 'CRM_RECENCY')
    // if (crmUserId) {
    //   url.searchParams.set('crm_user_id', crmUserId)
    // }
    // if (customer.customerTypeId) {
    //   url.searchParams.set('customer_type_id', String(customer.customerTypeId))
    // }
    // if (customer.customerType) {
    //   url.searchParams.set('customer_type', customer.customerType)
    // }

    window.open(SALES_APP_URL, '_blank')
    // console.log("url ", url.href.toString());
    
  } catch (err) {
    console.error('Failed to construct Sales App redirect URL:', err)
  }
}
